import { yupResolver } from '@hookform/resolvers/yup';
import { Button, Card, CardActionArea, CardContent, Typography } from '@mui/material';
import { LocalizationProvider, MobileDatePicker } from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { FormInput } from 'components/input/hook-form';
import { Layout } from 'components/layout';
import TableLoader from 'components/loader/TableLoader';
import { format } from 'date-fns';
import dayjs from 'dayjs';
import { useGetLeaveConfigApiQuery, useUpdateLeaveConfigApiMutation } from 'lib/api/admin/adminLeaveConfigApi';
import { Controller, useForm } from 'react-hook-form';
import Swal from 'sweetalert2';
import withReactContent from 'sweetalert2-react-content';
import * as yup from 'yup';

interface LeaveConfigFormValues {
    leave_cut_off_date: dayjs.Dayjs;
}

const LeaveConfigPage = () => {
    const { data: currentLeave, isLoading: currentLeaveIsLoading } = useGetLeaveConfigApiQuery();
    const [updateLeaveConfig] = useUpdateLeaveConfigApiMutation();
    const { handleSubmit, control, setValue } = useForm<LeaveConfigFormValues>({
        mode: 'onSubmit',
        values: {
            leave_cut_off_date: currentLeave?.data?.leave_cut_off_date ? dayjs(currentLeave.data.leave_cut_off_date) : dayjs()
        },
        resolver: yupResolver(
            yup
                .object({
                    leave_cut_off_date: yup.date().required('*Date is required')
                })
                .required()
        )
    });

    const onSubmit = (data: LeaveConfigFormValues) => {
        updateLeaveConfig({
            leave_cut_off_date: format(new Date(data.leave_cut_off_date.toISOString()), 'yyyy-MM-dd')
        })
            .unwrap()
            .then(() => {
                withReactContent(Swal).fire('Sukses', 'Berhasil mengubah data!', 'success');
            })
            .catch((error) => {
                console.error('Error:', error);
            });
    };

    return (
        <Layout headerTitle="Leave Config" pageTitle="Leave Config" disableBreadcrumb>
            {currentLeaveIsLoading ? (
                <TableLoader />
            ) : (
                <Card>
                    <CardContent>
                        <Typography variant="h4" component="h1" gutterBottom>
                            Current Leave Configurations
                        </Typography>
                        <LocalizationProvider dateAdapter={AdapterDayjs}>
                            <form onSubmit={handleSubmit(onSubmit)}>
                                <Controller
                                    name="leave_cut_off_date"
                                    control={control}
                                    render={({ field }) => (
                                        <MobileDatePicker
                                            value={field.value}
                                            slotProps={{ textField: { fullWidth: true } }}
                                            onChange={(date: dayjs.Dayjs | null) => {
                                                if (date) {
                                                    setValue('leave_cut_off_date', date, { shouldValidate: true });
                                                }
                                            }}
                                        />
                                    )}
                                />
                                <Button
                                    sx={{
                                        marginTop: '24px'
                                    }}
                                    size="large"
                                    type="submit"
                                >
                                    Update Leave Config
                                </Button>
                            </form>
                        </LocalizationProvider>
                    </CardContent>
                </Card>
            )}
        </Layout>
    );
};

export default LeaveConfigPage;
